import Vue from 'vue'

export default {//经常调用的接口

}